// extracted by mini-css-extract-plugin
export default {"modal":"Loader_modal__IFs2U","root":"Loader_root__jRgkk","loaderText":"Loader_loaderText__HRwim"};